import Breadcrumb from "../components/Breadcrumb";
import PageHeader from "../components/PageHeader";
import Quote from "../components/Quote";
import { faIdCard } from "@fortawesome/free-solid-svg-icons";

const AboutPage = () => {
  return (
    <div>
      <Breadcrumb names={["About Us"]} />
      <div className="container">
        <PageHeader icon={faIdCard} title="About Us" subtitle="On peut rire de tout mais pas avec n’importe qui." />
        <Quote text="Even I can't talk about myself for an hour." author="Ricky Gervais" />
        <div className="row">
          <div className="col-12">
            <p>
              I am an IT professional with over 20 years of experience, including more than a decade in leadership roles. I began my career as a Windows C programmer and, over time, expanded my technical expertise across a wide range of platforms, languages, and industries.
            </p>
            <ul>
              <li>
                <strong>OS</strong>: Windows, Linux, Aix, OS/2, OS/390.
              </li>
              <li>
                <strong>Programming Languages</strong>: C, C++, x86 Assembly, Java, Perl, PHP, Python, JavaScript, Smalltalk, and others
              </li>
              <li>
                <strong>Industries</strong>: Banking, Insurance, Telecommunications, Data Centers, SaaS
              </li>
            </ul>
            <p>Over the years, I've learned a few lessons that now shape how I approach technology and leadership:</p>
            <ul>
              <li>Platforms and programming languages are implementation details. A .NET developer will not combust when reading JavaScript.</li>
              <li>Technology tends to be logical and predictable. People are not.</li>
              <li>I am strongly motivated by helping others, despite not considering myself a “people person”. A contradiction, perhaps, but a productive one.</li>
              <li>As an engineer, my focus has always been on delivering reliable solutions that can evolve over time.</li>
            </ul>
            <p>As I moved into leadership roles, my priorities shifted toward bringing out the best in my teams while ensuring we delivered meaningful value to our customers. Strong teams, clear communication, and trust consistently outperformed any single technical decision.</p>
            <h3>Challenge Mode: Technical Support!</h3>
            <p>Throughout my career, I gravitated toward challenging roles. Leading a Technical Support or Customer Success organization stands out as one of the most demanding and rewarding experiences I've had.</p>
            <ul>
              <li>
                <strong>Support needs to know everything.</strong> Developers specialize in parts of the system. Operations engineers specialize in environments. Product managers focus on specific features. Support engineers, even at Tier 1, must understand the full product surface and be capable of guiding customers through complex troubleshooting scenarios. Training and continuous learning are essential to success.
              </li>
              <li>
                <strong>Support controls very little of its workload.</strong>Support teams depend heavily on the performance of every other department and are often the first to face customers when something goes wrong. Efficient communication across the organization is not optional; it is survival.
              </li>
              <li>
                <strong>Support has a reputation problem.</strong>Most people have experienced poor technical support at some point. This stigma follows support engineers daily. Building trust, credibility, and a strong reputation for a support organization is an ongoing challenge that can be deeply rewarding and occasionally frustrating.
              </li>
              <li>
                <strong>Support requires a holistic technical view.</strong>n a SaaS environment, support engineers must troubleshoot front-end behavior, back-end systems, third-party APIs, networking issues, and everything in between. When done well, customers should always feel they are speaking with an expert, regardless of ticket severity or tier.
              </li>
            </ul>
            <p>I found this environment compelling because it demands constant learning and keeps both technical skills and problem-solving instincts sharp.</p>
            <h3>Why “Codewriter”</h3>
            <p>Years ago, a coworker used to grab my attention by dancing and singing to the melody of <i>Low Rider</i> by War, replacing the lyrics with “Codewriter.” It was confusing, mildly unsettling, and undeniably effective.</p>
            <p>I leaned into the joke. I bought the domain <strong>codewriter.net</strong> and even changed my car's license plate. The name stuck, and so did the idea that writing code is, in its own way, a form of authorship.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
